import { render, staticRenderFns } from "./xxhdyx.vue?vue&type=template&id=78ad647a&scoped=true&"
import script from "./xxhdyx.vue?vue&type=script&lang=js&"
export * from "./xxhdyx.vue?vue&type=script&lang=js&"
import style0 from "./xxhdyx.vue?vue&type=style&index=0&id=78ad647a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ad647a",
  null
  
)

export default component.exports